import { SitesService } from './../../shared/services/sites.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { Site } from '@classes/site';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class SitesComponent extends DatatableBaseComponent implements OnInit {
  sites: Site[];

  displayedColumns = [
    'name',
    'client',
    'otherSite',
    'documentUrl',
    'siren',
    'options',
    'actions',
  ];
  dataSource: MatTableDataSource<Site>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private sitesSrv: SitesService,
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
    this.initSubscriptions();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.sites);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'client':
          return item.clients && item.clients.length > 0
            ? item.clients.map(c => c.name).join(', ')
            : '';
        default:
          return item[property];
      }
    };
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'clients':
            return currentTerm + (data.clients
              ? data.clients.map(c => c.name).join(' ')
              : '');
          default:
            return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
    this.dataSource.sort = this.sort;
  }

  private getRouteData(): void {
    this.route.data.subscribe((data: { sites: Site[] }) => {
      this.sites = data.sites;
      this.initTable();
    });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.sitesSrv.sitesListChanged.subscribe((sites) => {
        this.dataSource.data = sites || [];
        this.dataSource.sort = this.sort;
        this.onEditFinished();
      }),
    );
  }

  delete(idSite: string) {
    const confirmation = confirm(
      "Êtes-vous certain de vouloir supprimer ce donneur d'ordre ?",
    );

    if (confirmation) {
      this.sitesSrv.delete(idSite).subscribe(() => {
        this.uiSrv.showSnackbar('repository.sites.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
